
const moment = require('moment');

const {
	read: momentFromIso,
	write: momentToIso,
} = require('ko-extender-view-moment-from-iso');

const DATE_FORMAT = 'DD.MM.YYYY HH:mm';

const read = iso => {
	const m = momentFromIso(iso);
	if (!m.isValid()) {
		return iso;
	}
	return m.format(DATE_FORMAT);
};
const write = lrd => momentToIso(lrd && moment(lrd, DATE_FORMAT));
const localRussianDateTimeViewExtend = { view: { localRussianDateTime: { read, write } } };

module.exports = {
	localRussianDateTimeViewExtend,
	read,
	write,
};

